/**
 * Helper to trigger a browser file download from a Blob.
 *
 * NOTE: the former `exportData()` client-side ExcelJS/PapaParse exporter was
 * removed — it was dead code (zero callers) and wrote untyped cells (no number
 * formats, no real date cells). All real exports run server-side: the async
 * background job is generated by main-consumer (SheetJS, type-correct) or the
 * main-backend fallback (fastexcel), both driven by the canonical export
 * cell-format spec. Only this `downloadFile` helper is still used (by
 * PExportDeviceQR + AppBarDocumentBuilder for plain blobs).
 */
export const downloadFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};
